export const RATING = {
  min: 0,
  max: 5,
  step: 0.1
};
